import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import CustomDarkCheckbox from '../components/CustomDarkCheckbox';
import { toast } from "react-hot-toast";
import {
  AGENCY_CATEGORIES,
  CATEGORY_LIST,
  CATEGORY_LABELS,
  normalizeCategory,
} from "../constants/agencyCategories";
import {
  findProductAcrossCategories,
  updateProduct,
  uploadToCloudinary,
} from "../services/productService";

const EditProductPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id: routeId } = useParams();
  const initialTab = location.state?.activeTab || "Details";

  const [resolvedProduct, setResolvedProduct] = useState(location.state?.product || null);
  const [resolvedCategory, setResolvedCategory] = useState(
    location.state?.activeTab ? normalizeCategory(location.state.activeTab) : null
  );
  const [loadingProduct, setLoadingProduct] = useState(
    Boolean(routeId && !location.state?.product)
  );

  const initialProduct = resolvedProduct || {
    id: "",
    name: "",
    vendorName: "",
    Locat: "",
    rentalFee: "",
    description: "",
    rating: "",
    reviews: "",
    createdAt: "",
    updatedAt: new Date(),
    Category: "",
    price: "",
    quantity: "",
    images: "",
    imageCover: "",
    subcategory: "",
    color: "",
    size: "",
    brand: "",
    condition: "",
    model: "",
    transmission: "",
    fuel: "",
    seats: "",
    driver: "",
    area: "",
    bedrooms: "",
    bathrooms: "",
    cameras: "",
    pool: "",
    garden: "",
    capacity: "",
    type: "",
    buffet: "",
  };


  const [activeTab] = useState(initialTab);
  const [id, setID] = useState("");
  const [name, setName] = useState("");
  const [vendorName, setvendorName] = useState("");
  const [productLocation, setProductLocation] = useState("");

  const [Category, setCategory] = useState("");
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const [rentalFee, setrentalfee] = useState("");
  const [description, setdescription] = useState("");
  const [rating, setrating] = useState("");
  const [reviews, setreviews] = useState("");
  const [createdAt, setCreatedat] = useState("");
  const [updatedAt, setupdatedat] = useState("");
  const [images, setImages] = useState([null, null, null, null]);
  const [imageCover, setImageCover] = useState("");

  // extra fields
  const [subcategory, setSubcategory] = useState("");
  const [size, setSize] = useState("");
  const [brand, setBrand] = useState("");
  const [condition, setCondition] = useState("");
  const [color, setColor] = useState("");

  const [model, setModel] = useState("");
  const [transmission, setTransmission] = useState("");
  const [fuel, setFuel] = useState("");
  const [seats, setSeats] = useState("");
  const [driver, setDriver] = useState("");

  const [area, setArea] = useState("");
  const [bedrooms, setBedrooms] = useState("");
  const [bathrooms, setBathrooms] = useState("");
  const [cameras, setCameras] = useState(false);
  const [pool, setPool] = useState(false);
  const [garden, setGarden] = useState(false);

  const [capacity, setCapacity] = useState("");
  const [type, setType] = useState("");
  const [buffet, setBuffet] = useState("");

  const [isEditingID, setIsEditingID] = useState(false);
  const [isEditingVendor, setIsEditingVendor] = useState(false);
  const [isEditinglocation, setIsEditinglocation] = useState(false);
  const [isEditingrating, setIsEditingrating] = useState(false);
  const [isEditingcreatedat, setIsEditingcreatedat] = useState(false);
  const [isEditingupdatedat, setIsEditingupdatedat] = useState(false);


  const catToKey = {
    clothes: AGENCY_CATEGORIES.CLOTHES,
    clothing: AGENCY_CATEGORIES.CLOTHES,
    cars: AGENCY_CATEGORIES.CARS,
    car: AGENCY_CATEGORIES.CARS,
    wedding: AGENCY_CATEGORIES.WEDDING,
    "real-estate": AGENCY_CATEGORIES.REAL_ESTATE,
    realstate: AGENCY_CATEGORIES.REAL_ESTATE,
  };

  useEffect(() => {
    const loadById = async () => {
      if (!routeId || resolvedProduct) return;
      setLoadingProduct(true);
      try {
        const result = await findProductAcrossCategories(routeId);
        if (result) {
          setResolvedProduct(result.product);
          setResolvedCategory(result.category);
        } else {
          toast.error("Product not found");
          navigate("/products");
        }
      } catch (err) {
        toast.error(err?.friendlyMessage || "Failed to load product");
        navigate("/products");
      } finally {
        setLoadingProduct(false);
      }
    };
    loadById();
  }, [routeId, resolvedProduct, navigate]);

  useEffect(() => {
    setID(initialProduct.id || "");
    setName(initialProduct.name || "");
    setvendorName(initialProduct.vendorName || "");
    setProductLocation(initialProduct.location || "");
    setrentalfee(initialProduct.rentalFee || "");
    setdescription(initialProduct.description || "");
    setrating(initialProduct.rating || "");
    setCreatedat(initialProduct.createdAt || "");
    setupdatedat(initialProduct.updatedAt || "");
    setSubcategory(initialProduct.subcategory || "");
    setSize(initialProduct.size || "");
    setBrand(initialProduct.brand || "");
    setCondition(initialProduct.condition || "");
    setColor(initialProduct.color || "");
    setCategory(initialProduct.Category || "");
    setPrice(initialProduct.price || "");
    setQuantity(initialProduct.quantity || "");
    setModel(initialProduct.model || "");
    setTransmission(initialProduct.transmission || "");
    setFuel(initialProduct.fuel || "");
    setSeats(initialProduct.seats || "");
    setDriver(initialProduct.driver || "");
    setArea(initialProduct.area || "");
    setBedrooms(initialProduct.bedrooms || "");
    setBathrooms(initialProduct.bathrooms || "");
    setCameras(initialProduct.cameras || "");
    setPool(initialProduct.pool || "");
    setGarden(initialProduct.garden || "");
    setCapacity(initialProduct.capacity || "");
    setType(initialProduct.type || "");
    setBuffet(initialProduct.buffet || "");
    setImageCover(initialProduct.imageCover || "");

    let imagesArray = [null, null, null, null];
    if (Array.isArray(initialProduct.images)) {
      initialProduct.images.forEach((img, idx) => {
        if (img) imagesArray[idx] = img;
      });
    } else if (initialProduct.image) {
      imagesArray[0] = initialProduct.image;
    }
    setImages(imagesArray);
  }, [initialProduct]);

  if (loadingProduct) {
    return (
      <div className="md:p-10 p-4 text-agarly-gray">Loading product...</div>
    );
  }

  // رفع صورة واحدة لـ Cloudinary
const uploadImageToCloudinary = async (file) => uploadToCloudinary(file);



const handleImageChange = async (index, file, isCover = false) => {
  try {
    if (!file) return;

    const imageUrl = await uploadImageToCloudinary(file);

    if (isCover) {
      // 📌 cover image
      setImageCover(imageUrl);
    } else {
      // 📌 gallery images
      const newImages = [...images];
      newImages[index] = imageUrl;
      setImages(newImages);
    }

    toast.success("Image uploaded successfully!");
  } catch (err) {
    toast.error("Image upload failed, please try again.");
  }
};






  const handleImageRemove = (index, isCover = false) => {
  if (isCover) {
    setImageCover(null);
  } else {
    const newImages = [...images];
    newImages[index] = null;
    setImages(newImages);
  }
};

  const handleSave = async () => {
    try {
      const updatedProduct = {
        name: name || initialProduct.name,
        vendorName: vendorName || initialProduct.vendorName,
        location: productLocation || initialProduct.location,
        rentalFee: rentalFee || initialProduct.rentalFee,
        description: description || initialProduct.description,
        rating: rating || initialProduct.rating,
        createdAt: createdAt || initialProduct.createdAt,
        updatedAt: updatedAt || initialProduct.updatedAt,
        subcategory: subcategory || initialProduct.subcategory,
        size: size || initialProduct.size,
        brand: brand || initialProduct.brand,
        condition: condition || initialProduct.condition,
        color: color || initialProduct.color,
        Category: Category || initialProduct.Category,
        price: price || initialProduct.price,
        quantity: quantity || initialProduct.quantity,
        model: model || initialProduct.model,
        transmission: transmission || initialProduct.transmission,
        fuel: fuel || initialProduct.fuel,
        seats: seats || initialProduct.seats,
        driver: driver || initialProduct.driver,
        area: area || initialProduct.area,
        bedrooms: bedrooms || initialProduct.bedrooms,
        bathrooms: bathrooms || initialProduct.bathrooms,
        cameras: cameras || initialProduct.cameras,
        pool: pool || initialProduct.pool,
        garden: garden || initialProduct.garden,
        capacity: capacity || initialProduct.capacity,
        type: type || initialProduct.type,
        buffet: buffet || initialProduct.buffet,
        imageCover: imageCover || initialProduct.images[0],
      };

      const categoryKey =
        resolvedCategory ||
        normalizeCategory(Category || initialProduct.Category);
      const productId = initialProduct.id || id || routeId;

      const updatePromise = updateProduct(categoryKey, productId, updatedProduct);

      await toast.promise(
        updatePromise,
        {
          loading: "Updating product...",
          success: "Product updated successfully!",
          error: (err) =>
            err?.response?.data?.message ?? "Failed to update product, please try again.",
        },
        {
          success: { duration: 1800 },
          error: { duration: 3000 },
        }
      );

      navigate(`/products?selected=${categoryKey}`);
    } catch (error) {
      console.error("Update error:", error.response?.data || error.message);
      toast.error(error.message, { duration: 3000 });
    }
  };



  const handleDiscard = () => {
    setID(initialProduct.id || "");
    setName(initialProduct.name || "");
    setvendorName(initialProduct.vendorName || "");
    setProductLocation(initialProduct.Locat || "");
    setrentalfee(initialProduct.rentalFee || "");
    setdescription(initialProduct.description || "");
    setrating(initialProduct.rating || "");
    setCreatedat(initialProduct.createdAt || "");
    setupdatedat(initialProduct.updatedAt || "");
    setSubcategory(initialProduct.subcategory || "");
    setSize(initialProduct.size || "");
    setBrand(initialProduct.brand || "");
    setCondition(initialProduct.condition || "");
    setColor(initialProduct.color || "");
    setCategory(initialProduct.Category || "");
    setPrice(initialProduct.price || "");
    setQuantity(initialProduct.quantity || "");
    setModel(initialProduct.model || "");
    setTransmission(initialProduct.transmission || "");
    setFuel(initialProduct.fuel || "");
    setSeats(initialProduct.seats || "");
    setDriver(initialProduct.driver || "");
    setArea(initialProduct.area || "");
    setBedrooms(initialProduct.bedrooms || "");
    setBathrooms(initialProduct.bathrooms || "");
    setCameras(initialProduct.cameras || "");
    setPool(initialProduct.pool || "");
    setGarden(initialProduct.garden || "");
    setCapacity(initialProduct.capacity || "");
    setType(initialProduct.type || "");
    setBuffet(initialProduct.buffet || "");
    setImageCover(initialProduct.imageCover || "");

    setImages(
      Array.isArray(initialProduct.images)
        ? initialProduct.images
        : [null, null, null, null]
    );

    navigate(`/products?selected=${Category}`);
  };


  const categoryName =
    resolvedCategory ||
    normalizeCategory(Category || initialProduct.Category) ||
    AGENCY_CATEGORIES.CLOTHES;

  return (
    <div>
      <div className="md:p-10 p-4 pb-4 text-base gap-4 w-full">
        {/* Page Titles */}
        <h1 className="text-2xl font-bold mb-2 dark:text-gray-200">Products</h1>
        <p className="text-gray-600 pb-6 text-sm flex flex-wrap gap-1 items-center dark:text-gray-400">
          <Link to="/dashboard" className="hover:underline">Dashboard</Link> /{" "}
          <Link to="/products" className="hover:underline">Categories</Link> /{" "}
          {categoryName && (
            <>
              <Link to={`/products?selected=${categoryName}`} className="hover:underline">{categoryName}</Link> /{" "}
            </>
          )}
          <span className="agarly-gradient-text font-bold">
            Edit Product
          </span>
        </p>

        <div className="flex md:flex-row flex-col rounded-2xl md:p-0 p-2 min-h-screen gap-6 bg-gray-50 dark:bg-black">
          {/* Product Information */}
          <div className="bg-white rounded-2xl shadow p-6 md:w-[60%] w-full h-auto 
                      dark:bg-[#1A1A1B] dark:border dark:border-[#3D3D3D] dark:text-gray-200">
            <h2 className="text-2xl font-semibold mb-4">Product Information</h2>
            <p className="text-sm text-gray-400 mb-4 dark:text-gray-500">
              Fill in the product details below to add a new item to your catalog.
            </p>
            <div className="space-y-4">
              {!isEditingID && (
                <div className="space-y-2">
                  <label className="font-bold text-md dark:text-gray-300">ID</label>
                  <p className="w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm opacity-50 dark:border-gray-600 dark:bg-[#2A2A2B] dark:text-gray-400">
                    {initialProduct.id}
                  </p>
                </div>
              )}

              <div className="space-y-2">
                <label className="font-bold text-md dark:text-gray-300">Product Name</label>
                <input type="text" placeholder="Input product name"
                  className="w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-gray-700
                         dark:border-gray-600 dark:bg-[#1A1A1B]  dark:text-gray-200"
                  value={name} onChange={(e) => setName(e.target.value)} />
              </div>

              {!isEditingVendor && (
                <div className="w-full flex flex-col space-y-2">
                  <label className="font-bold text-md dark:text-gray-300">Vendor</label>
                  <p className="border-2 border-gray-300 rounded-lg px-3 py-3 text-sm opacity-50 focus:outline-none focus:ring-1 focus:ring-gray-700
                           dark:border-gray-600 dark:bg-[#2A2A2B] dark:text-gray-400">
                    {initialProduct.vendorName}
                  </p>
                </div>
              )}

              <div className="flex gap-4">
                <div className="w-1/2 flex flex-col space-y-2 relative">
                  <label className="font-bold text-md dark:text-gray-200">Product Category</label>
                  <select className="w-full border-2 border-gray-300 dark:border-[#3D3D3D] rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B]  dark:text-gray-200 pr-8 focus:outline-none focus:ring-1 focus:ring-gray-700" value={categoryName} onChange={(e) => setCategory(e.target.value)} >
                    <option value="">Select product category</option>
                    {CATEGORY_LIST.map((cat) => (
                      <option key={cat} value={cat}>{CATEGORY_LABELS[cat]}</option>
                    ))}

                  </select>
                </div>

                <div className="w-1/2 space-y-2">
                  <label className="font-bold text-md dark:text-gray-200">Rental fee</label>
                  <input type="text" placeholder="Input Rental Fee" className="w-full border-2 border-gray-300 dark:border-[#3D3D3D] rounded-lg px-3 py-3 text-sm dark:bg-[#1A1A1B]  dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-gray-700" value={rentalFee} onChange={(e) => setrentalfee(e.target.value)} />
                </div>
              </div>

              {!isEditinglocation && (
                <div className="space-y-2">
                  <label className="font-bold text-md dark:text-gray-200">Location</label>
                  <p className="border-2 border-gray-300 rounded-lg px-3 py-3 text-sm opacity-50 
                           dark:border-gray-600 dark:bg-[#2A2A2B] dark:text-gray-400">{productLocation}</p>
                </div>
              )}



              <div className="space-y-2">
                <label className="font-bold text-md dark:text-gray-200">Description</label>
                <textarea type="text" placeholder="Input Description" className="w-full h-[100px] border-2 border-gray-300 dark:border-[#3D3D3D] rounded-lg px-3 py-3 text-sm dark:bg-[#1A1A1B] dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-gray-700" value={description} onChange={(e) => setdescription(e.target.value)} />
              </div>

              {!isEditingrating && (
                <div className="space-y-2">
                  <label className="font-bold text-md dark:text-gray-200">Rating</label>
                  <p className="border-2 border-gray-300 rounded-lg px-3 py-3 text-sm opacity-50 
                           dark:border-gray-600 dark:bg-[#2A2A2B] dark:text-gray-400">{initialProduct.rating}</p>
                </div>
              )}


              <div className="flex gap-4">
                {!isEditingcreatedat && (
                  <div className="w-1/2 flex flex-col space-y-2">
                    <label className="font-bold text-md dark:text-gray-200">Created At</label>
                    <p className="border-2 border-gray-300 rounded-lg px-3 py-3 text-sm opacity-50 
                           dark:border-gray-600 dark:bg-[#2A2A2B] dark:text-gray-400" > {initialProduct.createdAt} </p>
                  </div>
                )}

                {!isEditingupdatedat && (
                  <div className="w-1/2 flex flex-col space-y-2">
                    <label className="font-bold text-md dark:text-gray-200">Updated At</label>
                    <p className="border-2 border-gray-300 rounded-lg px-3 py-3 text-sm opacity-50 
                           dark:border-gray-600 dark:bg-[#2A2A2B] dark:text-gray-400"> {initialProduct.updatedAt} </p>
                  </div>
                )}

              </div>
            </div>

            {normalizeCategory(categoryName) === AGENCY_CATEGORIES.CLOTHES && (
              <div className="space-y-4">
                <div className="flex flex-col space-y-2">
                  <label className="font-bold text-md mt-2 text-gray-800 dark:text-gray-200">Subcategory</label>
                  <select
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 pr-8"
                    value={subcategory}
                    onChange={(e) => setSubcategory(e.target.value)}
                  >
                    <option value="">Select</option>
                      <option value="68a13d58b0ef38d4e9553876">Men's Suits</option>
                      <option value="68a13d6bb0ef38d4e9553879">Women's Wedding Dresses</option>
                      <option value="68a13d7ab0ef38d4e955387c">Woman Soiree Dresses</option>
                  </select>
                </div>

                <div className="flex gap-4">
                  <div className="w-1/2 flex flex-col space-y-2">
                    <label className="font-bold text-md text-gray-800 dark:text-gray-200">Size</label>
                    <input
                      type="text"
                      placeholder="Size"
                      className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-gray-700"
                      value={size}
                      onChange={(e) => setSize(e.target.value)}
                    />
                  </div>

                  <div className="w-1/2 flex flex-col space-y-2">
                    <label className="font-bold text-md text-gray-800 dark:text-gray-200">Color</label>
                    <input
                      type="text"
                      placeholder="Color"
                      className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-gray-700"
                      value={color}
                      onChange={(e) => setColor(e.target.value)}
                    />
                  </div>
                </div>

                <div className="flex flex-col space-y-2">
                  <label className="font-bold text-md text-gray-800 dark:text-gray-200">Brand</label>
                  <input
                    type="text"
                    placeholder="Brand"
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={brand}
                    onChange={(e) => setBrand(e.target.value)}
                  />
                </div>

                <div className="flex flex-col space-y-2">
                  <label className="font-bold text-md text-gray-800 dark:text-gray-200">Condition</label>
                  <select
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 pr-8 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={condition}
                    onChange={(e) => setCondition(e.target.value)}
                  >
                    <option value="">Select Condition</option>
                    <option>Used many times</option>
                    <option>Medium used</option>
                    <option>As new</option>
                  </select>
                </div>
              </div>
            )}


            {normalizeCategory(categoryName) === AGENCY_CATEGORIES.CARS && (
              <div className="space-y-4">
                <div className="w-full flex flex-col space-y-2">
                  <label className="font-bold text-md mt-2 text-gray-800 dark:text-gray-200">Subcategory</label>
                  <select
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 pr-8"
                    value={subcategory}
                    onChange={(e) => setSubcategory(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="68a13b73b0ef38d4e9553862">SUV</option>
                    <option value="68a13b8bb0ef38d4e9553865">Electric/Hybrid</option>
                    <option value="68a13b61b0ef38d4e955385f">Sports</option>
                    <option value="68a13b53b0ef38d4e955385c">Luxury</option>
                    <option value="">4x4</option>
                    <option value="">Cabriolet</option>
                    <option value="">Coupe</option>
                    <option value="">Pickup</option>
                    <option value="">Van / Bus</option>
                    <option value="">Other</option>
                  </select>
                </div>

                <div className="flex flex-col space-y-2">
                  <label className="font-bold text-md text-gray-800 dark:text-gray-200">Brand</label>
                  <input
                    type="text"
                    placeholder="Input Brand"
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={brand}
                    onChange={(e) => setBrand(e.target.value)}
                  />
                </div>

                <div className="flex flex-col space-y-2">
                  <label className="font-bold text-md text-gray-800 dark:text-gray-200">Model</label>
                  <input
                    type="text"
                    placeholder="Input Model"
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={model}
                    onChange={(e) => setModel(e.target.value)}
                  />
                </div>

                <div className="w-full flex flex-col space-y-2">
                  <label className="font-bold text-md mt-2 text-gray-800 dark:text-gray-200">Transmission</label>
                  <select
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 pr-8 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={transmission}
                    onChange={(e) => setTransmission(e.target.value)}
                  >
                    <option>Automatic</option>
                    <option>Manual</option>
                  </select>
                </div>

                <div className="w-full flex flex-col space-y-2">
                  <label className="font-bold text-md mt-2 text-gray-800 dark:text-gray-200">Fuel</label>
                  <select
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 pr-8 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={fuel}
                    onChange={(e) => setFuel(e.target.value)}
                  >
                    <option>Benzine</option>
                    <option>Diesel</option>
                    <option>Electric</option>
                    <option>Petrol</option>
                    <option>Natural Gas</option>
                  </select>
                </div>

                <div className="w-full flex flex-col space-y-2">
                  <label className="font-bold text-md mt-2 text-gray-800 dark:text-gray-200">Seats</label>
                  <input
                    type="number"
                    placeholder="Seats"
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={seats}
                    onChange={(e) => setSeats(e.target.value)}
                  />
                </div>

                <div className="w-full flex flex-col space-y-2">
                  <label className="font-bold text-md mt-2 text-gray-800 dark:text-gray-200">Driver</label>
                  <select
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 pr-8 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={driver}
                    onChange={(e) => setDriver(e.target.value)}
                  >
                    <option>With driver</option>
                    <option>Without driver</option>
                  </select>
                </div>
              </div>
            )}


            {normalizeCategory(categoryName) === AGENCY_CATEGORIES.REAL_ESTATE && (
              <div className="space-y-4">
                <div className="w-full flex flex-col space-y-2">
                  <label className="font-bold text-md mt-2 text-gray-800 dark:text-gray-200">Subcategory</label>
                  <select
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 pr-8 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={subcategory}
                    onChange={(e) => setSubcategory(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="68a13e37b0ef38d4e9553887">Appartment</option>
                    <option value="68a13e2db0ef38d4e9553884">Villas</option>
                    <option>Duplex</option>
                    <option value="68a13e43b0ef38d4e955388a">Townhouse</option>
                    <option value="68a13e57b0ef38d4e955388d">Commercial</option>
                    <option value="68a13e63b0ef38d4e9553890">Coastal</option>
                  </select>
                </div>

                <div className="w-full flex flex-col space-y-2 mt-2">
                  <label className="font-bold text-md mt-2 text-gray-800 dark:text-gray-200">Area (m²)</label>
                  <input
                    type="number"
                    placeholder="Area (m²)"
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={area}
                    onChange={(e) => setArea(e.target.value)}
                  />
                </div>

                <div className="w-full flex flex-col space-y-2">
                  <label className="font-bold text-md mt-2 text-gray-800 dark:text-gray-200">Bedrooms Num</label>
                  <input
                    type="number"
                    placeholder="Bedrooms"
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={bedrooms}
                    onChange={(e) => setBedrooms(e.target.value)}
                  />
                </div>

                <div className="w-full flex flex-col space-y-2">
                  <label className="font-bold text-md mt-2 text-gray-800 dark:text-gray-200">Bathrooms Num</label>
                  <input
                    type="number"
                    placeholder="Bathrooms"
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={bathrooms}
                    onChange={(e) => setBathrooms(e.target.value)}
                  />
                </div>

                <div className="flex justify-between p-4 items-center text-gray-800 dark:text-gray-200">
                  <label className="items-center">
                    <CustomDarkCheckbox checked={cameras} onChange={(e) => setCameras(e.target.checked)} className="mr-1" /> Cameras
                  </label>
                  <label>
                    <CustomDarkCheckbox checked={pool} onChange={(e) => setPool(e.target.checked)} className="mr-1" /> Pool
                  </label>
                  <label>
                    <CustomDarkCheckbox checked={garden} onChange={(e) => setGarden(e.target.checked)} className="mr-1" /> Garden
                  </label>
                </div>
              </div>
            )}

            {normalizeCategory(categoryName) === AGENCY_CATEGORIES.WEDDING && (
              <div className="space-y-4">
                <div className="w-full flex flex-col space-y-2 mt-2">
                  <label className="font-bold text-md mt-2 text-gray-800 dark:text-gray-200">Subcategory</label>
                  <select
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 pr-8 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={subcategory}
                    onChange={(e) => setSubcategory(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="68a13f53b0ef38d4e9553899">Luxury Hotels</option>
                    <option value="68a13f69b0ef38d4e955389c">Beach Resorts</option>
                    <option value="68a13f79b0ef38d4e955389f">Garden Venues</option>
                    <option value="68a13f9eb0ef38d4e95538a5">Water Venues</option>
                    <option value="68a13f91b0ef38d4e95538a2">Private Venues</option>
                  </select>
                </div>

                <div className="w-full flex flex-col space-y-2">
                  <label className="font-bold text-md text-gray-800 dark:text-gray-200">Area (m²)</label>
                  <input
                    type="number"
                    placeholder="Area (m²)"
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={area}
                    onChange={(e) => setArea(e.target.value)}
                  />
                </div>

                <div className="w-full flex flex-col space-y-2">
                  <label className="font-bold text-md text-gray-800 dark:text-gray-200">Capacity Up to</label>
                  <input
                    type="number"
                    placeholder="Capacity"
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={capacity}
                    onChange={(e) => setCapacity(e.target.value)}
                  />
                </div>

                <div className="w-full flex flex-col space-y-2">
                  <label className="font-bold text-md text-gray-800 dark:text-gray-200">Type</label>
                  <select
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 pr-8 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                  >
                    <option>Indoor</option>
                    <option>Open air</option>
                  </select>
                </div>

                <div className="w-full flex flex-col space-y-2">
                  <label className="font-bold text-md text-gray-800 dark:text-gray-200">Buffet</label>
                  <select
                    className="w-full border-2 border-gray-300 dark:border-gray-600 rounded-lg px-3 py-3 text-sm bg-white dark:bg-[#1A1A1B] text-gray-800 dark:text-gray-200 pr-8 focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={buffet}
                    onChange={(e) => setBuffet(e.target.value)}
                  >
                    <option>Open buffet</option>
                    <option>Meals</option>
                    <option>Desserts</option>
                  </select>
                </div>
              </div>
            )}
          </div>
          {/* Product Images & Buttons */}
          <div className="md:w-[45%] w-full space-y-6 flex flex-col">
            {/* Images */}
            <div className="bg-white dark:bg-[#1A1A1B] dark:border dark:border-[#3D3D3D] rounded-2xl shadow p-6 h-auto">
              <h2 className="text-2xl font-semibold mb-4 dark:text-gray-200">Product Images</h2>
              <p className="text-sm text-gray-600 mb-4 dark:text-gray-400">
                <span className="text-blue-400">Note:</span> Format photos SVG, PNG, or JPG (Max size 4mb)
              </p>
              <div className="">
                <h3 className="text-lg font-semibold mb-2 dark:text-gray-200">Cover Image</h3>
              

                {imageCover ? (
                  <div className="relative w-[150px] h-[150px] mb-4">
                    <label className="border border-dashed border-blue-400 rounded-xl bg-blue-50 dark:bg-[#2D2D2D] dark:border-[#3D3D3D] p-4 flex flex-col items-center justify-center cursor-pointer w-full h-full">
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/svg+xml"
                        className="hidden"
                        onChange={(e) => handleImageChange(null, e.target.files[0], true)}
                      />
                      <img
                        src={imageCover}
                        className="w-full h-full object-cover rounded-lg"
                      />
                    </label>

                    {/* ✅ زرار المسح هنا */}
                    <button
                      onClick={() => handleImageRemove(null, true)}
                      className="absolute top-2 right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm"
                    >
                      ×
                    </button>
                  </div>
                ) : (
                  <div className="w-full relative">
                    <label className="border border-dashed border-blue-400 rounded-xl bg-blue-50 dark:bg-[#2D2D2D] dark:border-[#3D3D3D] p-4 flex flex-col items-center justify-center cursor-pointer w-full h-full">
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/svg+xml"
                        className="hidden"
                        onChange={(e) => handleImageChange(null, e.target.files[0], true)}
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                      >
                        <defs>
                          <linearGradient id="grad-cover" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#5DEBFF" />
                            <stop offset="100%" stopColor="#7CC9FF" />
                          </linearGradient>
                        </defs>
                        <path
                          fill="url(#grad-cover)"
                          d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14h18zM5 5h14v14H5V5zm2 10l2.5-3 3.5 4.5 2.5-3L19 17H7z"
                        />
                      </svg>
                      <p className="text-xs mt-1 dark:text-gray-400">
                        Upload Image Cover
                      </p>
                    </label>
                  </div>
                )}
              </div>

              <div className="flex flex-wrap gap-3 mt-3">
                {(images || [null, null, null, null]).map((img, index) => (
                  <div key={index} className="relative md:w-[100px] md:h-[100px] min-w-[100px] min-h-[100px] w-[47%]">
                    <label className="border border-dashed border-blue-400 rounded-xl bg-blue-50 dark:bg-[#2D2D2D] dark:border-[#3D3D3D] p-4 flex flex-col items-center justify-center cursor-pointer w-full h-full">
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/svg+xml"
                        className="hidden"
                        onChange={(e) => handleImageChange(index, e.target.files[0], false)}
                      />
                      {img ? (
                        <img
                          src={img}
                          alt={`Product ${index + 1}`}
                          className="w-full h-full object-cover rounded-lg" />
                      ) : (
                        <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24">
                            <defs>
                              <linearGradient id={`grad-${index}`} x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stopColor="#5DEBFF" />
                                <stop offset="100%" stopColor="#7CC9FF" />
                              </linearGradient>
                            </defs>
                            <path
                              fill={`url(#grad-${index})`}
                              d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14h18zM5 5h14v14H5V5zm2 10l2.5-3 3.5 4.5 2.5-3L19 17H7z"
                            />
                          </svg>
                          <p className="text-xs mt-1 dark:text-gray-400">Photo {index + 1}</p>
                        </>
                      )}
                    </label>

                    {img && (
                      <button
                        onClick={() => handleImageRemove(index, false)}
                        className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs"
                      >
                        ×
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Buttons */}
            <div className="flex justify-between gap-4">
              <button
                onClick={handleDiscard}
                className="bg-gray-300 text-gray-700 hover:opacity-90 transition py-2 px-4 rounded-xl dark:bg-[#2D2D2D] dark:text-gray-200"
                style={{
                  'border-radius': "10px",
                  padding: "2px",
                  background: "linear-gradient(to right, #5DEBFF, #7CC9FF)",
                }}
              >
                <div className="flex items-center justify-center rounded-xl bg-white dark:bg-[#1A1A1B]"
                  style={{
                    'border-radius': "9px",
                    height: "100%",
                    width: "100%",
                    padding: "10px",
                    transition: "all 0.3s ease",
                  }}>
                  <span className="agarly-gradient-text font-bold ">Discard Changes</span>
                </div>
              </button>
              <button
                onClick={handleSave}
                className="agarly-btn-primary text-agarly-dark hover:opacity-90 transition py-2 px-4 rounded-xl font-bold dark:text-gray-800"
              >
                Save Product
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProductPage;
